__turbopack_context__.v({
  "blink": "Journals-module-scss-module__iFtA8a__blink",
  "columns3": "Journals-module-scss-module__iFtA8a__columns3",
  "journals": "Journals-module-scss-module__iFtA8a__journals",
  "sectionCentered": "Journals-module-scss-module__iFtA8a__sectionCentered",
  "sectionColumns": "Journals-module-scss-module__iFtA8a__sectionColumns",
  "title": "Journals-module-scss-module__iFtA8a__title",
});
